/**
 * Runtime configuration of the school app, read from Vite's `VITE_*` variables at build time
 * (`apps/web/.env` for dev; the hosting pipeline sets them per environment).
 */
export const config = {
  apiUrl: import.meta.env.VITE_API_URL as string,
  cognito: {
    userPoolId: import.meta.env.VITE_COGNITO_USER_POOL_ID as string,
    clientId: import.meta.env.VITE_COGNITO_CLIENT_ID as string,
  },
  /**
   * The MentorIA demo, behind a flag until activation and the mobile app exist (#20).
   */
  mentoria: {
    enabled: import.meta.env.VITE_MENTORIA_ENABLED === 'true',
    streamUrl: (import.meta.env.VITE_MENTORIA_STREAM_URL as string | undefined) ?? '',
  },
  /**
   * Error reporting; empty DSN means off (the operator creates the Sentry projects, #8).
   */
  sentry: {
    dsn: (import.meta.env.VITE_SENTRY_DSN as string | undefined) ?? '',
    release: (import.meta.env.VITE_APP_VERSION as string | undefined) ?? 'local',
    environment: (import.meta.env.VITE_ENVIRONMENT as string | undefined) ?? 'local',
  },
} as const;

for (const [key, value] of Object.entries({
  VITE_API_URL: config.apiUrl,
  VITE_COGNITO_USER_POOL_ID: config.cognito.userPoolId,
  VITE_COGNITO_CLIENT_ID: config.cognito.clientId,
})) {
  if (!value) {
    throw new Error(`Missing ${key}: add it to apps/web/.env or the build environment`);
  }
}
